exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".product-categories{display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/catalog/shared/components/product-categories/product-categories.cmp.scss
// module id = 824
// module chunks = 1